import { memo, useEffect } from "react"
import { Button, Flex, Form, Input, Space, Spin } from "antd";
import { t } from "i18next";
import TextArea from "antd/es/input/TextArea";
import { toast } from "react-toastify";
import { PmsIntegrationsService } from "../../services/PmsIntegrationsService";
import $ from "jquery";
import { useMutation, useQuery } from "react-query";
import { mdlPmsIntegrationsGetInformationRequest } from "../../models/service-models/pmsIntegrations/PmsIntegrationsGetInformationRequest";
import { ObjectHelper } from "../../utils/ObjectHelper";
import { useAppSelector } from "../../store/Hooks";
import { mdlHotelListRequest } from "../../models/service-models/hotel/HotelListRequest";
import { HotelService } from "../../services/HotelService";
import { mdlHotel } from "../../models/domain/Hotel";

export type GetInformationPropType = {
    fnCloseModal?: Function;
}

export const GetInformation = (props: GetInformationPropType) => {
    const siteStore = useAppSelector((state) => state.site);
    const [form] = Form.useForm<mdlPmsIntegrationsGetInformationRequest>();

    useEffect(() => {
        if (!data) {
            refetch();
        }
    }, [props]);

    const closeModal = () => {
        form.resetFields();
        props.fnCloseModal && props.fnCloseModal();
    }

    const {
        data,
        isLoading,
        isError,
        refetch
    } = useQuery(
        ["getHotels"],
        () => {
            var request: mdlHotelListRequest = { pageSize: 0 };
            return HotelService.List(request);
        },
        {
            refetchOnWindowFocus: false,
            enabled: false
        }
    );

    useEffect(() => {
        if (data) {
            form.setFieldsValue({
                title: siteStore.user?.firstName + ' ' + siteStore.user?.lastName,
                email: siteStore.user?.email,
                phone: siteStore.user?.phone || siteStore?.user?.mobile
            });
            const hotelIds: string[] = siteStore.user?.hotelIds || [];
            if (hotelIds && hotelIds.length > 0) {
                const hotelRecord: mdlHotel | undefined = data.body?.data?.find((hotel) => hotel.id === hotelIds[0]);
                if (hotelRecord) {
                    form.setFieldsValue({
                        hotelName: hotelRecord.localName
                    });
                }
            }
        }
    }, [data]);

    const { mutateAsync: saveInformationRequest, isLoading: mutateLoading, data: mutatedData } = useMutation(
        (data: mdlPmsIntegrationsGetInformationRequest) => PmsIntegrationsService.CreateInformationRequest(data as mdlPmsIntegrationsGetInformationRequest),
        {
            onError: error => {
                console.log(error);
            },
            onMutate(variables: mdlPmsIntegrationsGetInformationRequest) {
                variables.type = "PMSInfo";
            },
            onSuccess(data, variables, context) {
                if (data.header && data.header.success && data.body?.isSuccessful === true) {
                    toast.success(t("common.success"));
                    closeModal();
                }
                else {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            }
        }
    );

    return (
        <>
            <Spin spinning={isLoading || mutateLoading}>
                <Form
                    form={form}
                    name="get-information-form"
                    layout="vertical"
                    autoComplete="off"
                    onFinish={async (values) => saveInformationRequest(values)}
                >
                    <Form.Item<mdlPmsIntegrationsGetInformationRequest>
                        label={t("pmsIntegrations.hotelName")}
                        name="hotelName"
                        rules={[{ required: true, message: t("common.required") }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item<mdlPmsIntegrationsGetInformationRequest>
                        label={t("pmsIntegrations.nameSurname")}
                        name="title"
                        rules={[{ required: true, message: t("common.required") }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item<mdlPmsIntegrationsGetInformationRequest>
                        label={t("pmsIntegrations.phoneNumber")}
                        name="phone"
                        rules={[{ required: true, message: t("common.required") }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item<mdlPmsIntegrationsGetInformationRequest>
                        label={t("pmsIntegrations.eMail")}
                        name="email"
                        rules={[{ required: true, message: t("common.required") }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item<mdlPmsIntegrationsGetInformationRequest>
                        label={t("pmsIntegrations.descriptionField")}
                        name="description"
                    >
                        <TextArea rows={4} />
                    </Form.Item>
                    <Form.Item<mdlPmsIntegrationsGetInformationRequest>
                        label={t("pmsIntegrations.pmsProgram")}
                        name="pmsType"
                    >
                        <Input />
                    </Form.Item>

                    <Flex align="center" justify="flex-end">
                        <Space size="small">
                            <Button type="primary" htmlType="submit">{t("common.send")}</Button>
                            <Button type="primary" danger htmlType="submit" onClick={closeModal}>{t("common.close")}</Button>
                        </Space>
                    </Flex>
                </Form>
            </Spin>
        </>
    );
}